import React, {useEffect, useState} from "react";
import InfiniteScroll from "react-infinite-scroller";
import {useDispatch, useSelector} from "react-redux";
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Breadcrumbs from "../../../components/breadcrumbs";
import Button from "../../../components/button";
import Input from "../../../components/input";
import ItemList1 from "../../../components/item-list-1";
import Search from "../../../components/search";
import SelectInput from "../../../components/select";
import TextArea from "../../../components/text-area";
import {
    clear_purchase,
    CREATE_PURCHASE,
    createPurchase,
    getAllPurchase,
    get_report,
    GET_REPORT,
    getItemPurchase, 
    updatePurchase, 
    UPDATE_PURCHASE
} from '../../../redux/purchases';
import Select from "react-select";
import LoadingSpinner from "../../../components/loading-spinner";
import Card from "../../../components/card";
import Modal from "../../../components/modal";
import {get_status, URLAPI} from "../../../config";
import {getAllReasonPurchases} from "../../../redux/reason_purchases";
import {get_all_companies} from "../../../redux/company";
import CheckBox from "../../../components/check-box";
import {getAllProduct} from "../../../redux/products";
import {
    clear_detail_purchase,
    CREATE_DETAIL_PURCHASE,
    createDetailPurchase, DELETE_DETAIL_PURCHASE,
    deleteDetailPurchase
} from "../../../redux/detail_purchases";


const PurchaseAdmin = (props) => {
    const dispatch = useDispatch();

    const _get_all_purchase = useSelector((state) => state.purchase_module._get_all_purchase);
    const _get_all_product = useSelector((state) => state.product_module._get_all_product);

    const _get_all_reason_purchase = useSelector((state) => state.reason_purchases_module._get_all_reason_purchases);

    const _create_purchase = useSelector((state) => state.purchase_module._create_purchase);
    const _update_purchase = useSelector((state) => state.purchase_module._update_purchase);

    const _create_detail_purchase = useSelector((state) => state.detail_purchase_module._create_detail_purchase);
    // const _update_detail_purchase = useSelector((state) => state.detail_purchase_module._update_detail_purchase);
    const _delete_detail_purchase = useSelector((state) => state.detail_purchase_module._delete_detail_purchase);

    const _get_report = useSelector((store) => store.purchase_module._get_report);
    const {token} = useSelector((state) => state.users_module.login.data) || null;

    useEffect(() => {
        dispatch(getAllPurchase(token));
        // eslint-disable-next-line
    }, [token, dispatch]);

    const userEstablishmentsList = useSelector(
        (state) => state.users_module._session_data.data
    );

    const [showDetail, setShowDetail] = useState(false);
    const [showSibarLeft, setShowSibarLeft] = useState(false);
    const [showSibarRight, setShowSibarRight] = useState(false);
    const [showOverlay, setShowOverlay] = useState(false);
    const [allChecked, setAllChecked] = useState(false);
    const [establishment, setEstablishment] = useState([]);
    const [reasonPurchase, setReasonPurchase] = useState([]);
    const [products, setProducts] = useState([]);
    const [optionProducts, setOptionProducts] = useState([]);

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        let array = []
        if (userEstablishmentsList) {
            if (userEstablishmentsList.establecimientos) {
                array = userEstablishmentsList.establecimientos.map(element => {
                    return {
                        value: element.id,
                        label: element.nombre + ' (' + element.codigo + ')',
                    }
                })
            }
        }
        setEstablishment(array)
    }, [userEstablishmentsList])


    useEffect(() => {
        if (_get_all_reason_purchase && _get_all_reason_purchase.data && _get_all_reason_purchase.data.datos) {
            let array = _get_all_reason_purchase.data.datos.filter(x => x.activo === true);
            setReasonPurchase(array);
        }
    }, [_get_all_reason_purchase]);

     useEffect(() => {
        if (_get_all_product && _get_all_product.data && _get_all_product.data.datos) {
            let array = [];
            // eslint-disable-next-line
            _get_all_product.data.datos.map(x => {
                if (x.activo === true) {
                    array.push({
                        value: x.id,
                        label: x.descripcion
                    })
                }
            });
            setOptionProducts(array);
        }
    }, [_get_all_product]);


    /* Creating an array of objects. */
    const filter_options = [
        {name: 'Rango de fechas', id: 1},
        {name: 'Establecimiento', id: 2},
    ];

    const [range_date, setRangeDate] = useState({
        visible: false,
        date_start: '',
        date_end: ''
    })

    const [other_filter, setOtherFilter] = useState({
        visible_establishment: false,
        id_establishment: 0,
    });

    const [datas, setDatas] = useState([]);
    const [count, setCount] = useState(0);
    const [HasMore, setHasMore] = useState(true);

    // eslint-disable-next-line
    const initForm = {
        id: 0,
        descripcion: "",
        id_establecimiento: 0,
        presupuesto: false,
        productos: [],
    };
    
    // eslint-disable-next-line
    const [form, setForm] = useState(initForm);

    const [permisos, setPermisos] = useState([]);

    useEffect(() => {
        if (_create_purchase.status === 201) {
            toast.success("Compra creada correctamente", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setForm(initForm);
            setShowOverlay(false);
            dispatch(clear_purchase(CREATE_PURCHASE));
            dispatch(getAllPurchase(token, 1));
            setShowSibarRight(false);
            setIsLoading(false);
        } else if (_create_purchase.status !== 0) {
            toast.error(_create_purchase.message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setForm(initForm);
            setShowOverlay(false);
            setShowSibarRight(false);
            dispatch(clear_purchase(CREATE_PURCHASE));
            setIsLoading(false);
        }
    }, [_create_purchase, dispatch, initForm, token]);

    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);
        }
        if (_get_all_purchase && _get_all_purchase.data && _get_all_purchase.data.datos) {
            setDatas(_get_all_purchase.data.datos);
        }

    }, [_get_all_purchase, count, props]);

    const loadFunc = () => {
        if (_get_all_purchase.data.datos) {
            if (_get_all_purchase.data.datos.length > count) {
                const ordenado = _get_all_purchase.data.datos.sort((a, b) => {
                    return new Date(b.fecha_creacion + ' 00:00:00') - new Date(a.fecha_creacion + ' 00:00:00');
                });
                setDatas([...datas, ...ordenado.slice(count, count + 10)]);
                setCount(count + 10);
            }
            setHasMore(false);
        }
    };

    const filterToday = (e) => {
        setEstablishmentSelectFilter([]);
        if (e.target.value === "0") {
            setDatas(_get_all_purchase.data.datos);
            setRangeDate({
                date_end: '',
                date_start: '',
                visible: false
            });
            setOtherFilter({
                visible_establishment: false,
                id_establishment: 0,
            });
        }
        if (e.target.value === '1') {
            setRangeDate({
                date_end: '',
                date_start: '',
                visible: true
            });
        } else {
            setRangeDate({
                date_end: '',
                date_start: '',
                visible: false
            });
        }
        if (e.target.value === '2') {
            if (e.target.value === '2') {
                dispatch(get_all_companies(token));
                setOtherFilter({
                    visible_establishment: true,
                    id_establishment: 0,
                });
            }
        } else {
            setOtherFilter({
                visible_establishment: false,
                id_establishment: 0,
            });
        }
    }

    const handleChangePresupuesto = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.checked,
        });
    }

    const handleChange = (e) => {
        if (e.target.name === "id_establecimiento") {
            setForm({
                ...form,
                [e.target.name]: parseInt(e.target.value),
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    }

    const [establishment_select, setEstablishmentSelect] = useState([]);

    const handleChangeEstablishment = (e) => {
        setForm({
            ...form,
            // eslint-disable-next-line
            ['id_establecimiento']: parseInt(e.value),
        });
        setEstablishmentSelect(e);
    }


    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);

        form.productos = products

        if (form.id_establecimiento === 0) {
            toast.error("Debe seleccionar el establecimiento");
            setIsLoading(false);
            return;
        }

        if (form.descripcion === "") {
            toast.error("Debe ingresar una descripción");
            setIsLoading(false);
            return;
        }

        if (form.productos.length === 0) {
            toast.error("Debe agregar al menos un producto");
            setIsLoading(false);
            return;
        }
        dispatch(createPurchase(token, form))
    }

    const handleSearch = (e) => {
        setIsLoading(true);
        if (e.target.value === "") {
            setDatas(_get_all_purchase.data.datos);
            setIsLoading(false);
            return;
        }
        setDatas([]);
        let nombre = e.target.value;
        nombre = nombre.trim();
        let re = new RegExp(nombre, "i");
        // eslint-disable-next-line
        let filtro = _get_all_purchase.data.datos.filter(element => {
            if (element.establecimiento.match(re) != null || element.secuencial.match(re) != null) {
                return element;
            }
        })
        setDatas(filtro);
        setIsLoading(false);
    }

    const handleFilterRangeDate = (e) => {
        if (e.target.name === 'date_start') {
            range_date.date_start = e.target.value
        }
        if (e.target.name === 'date_end') {
            range_date.date_end = e.target.value
        }

        if (range_date.date_start !== '' && range_date.date_end !== '') {
            let date_start = new Date(range_date.date_start + ' 00:00:00');
            let date_end = new Date(range_date.date_end + ' 23:59:59');
            // eslint-disable-next-line
            let final = _get_all_purchase.data.datos.filter(x => {
                    if (x.fecha_creacion) {
                        let fecha = new Date(x.fecha_creacion);
                        if (fecha.getTime() >= date_start.getTime() && fecha.getTime() <= date_end.getTime()) {
                            return x;
                        }
                    }
                }
            )
            setDatas(final);
        }
    }

    useEffect(() => {
        if (_get_report.status === 200) {
            toast.success(_get_report.data.mensaje);
            dispatch(clear_purchase(GET_REPORT));
            setIsLoading(false);
        } else if (_get_report.status !== 0) {
            toast.error(_get_report.message);
            dispatch(clear_purchase(GET_REPORT));
            setIsLoading(false);
        }
    }, [_get_report, dispatch]);

    const handleGenerateReport = (e) => {
        e.preventDefault();
        setIsLoading(true);
        dispatch(get_report({
            'fecha_inicio': range_date.date_start,
            'fecha_fin': range_date.date_end,
            'id_establecimiento': other_filter.id_establishment,
        }, token));

    }

    const [establishment_select_filter, setEstablishmentSelectFilter] = useState([]);

    const handleChangeEstablishmentFilter = (e) => {
        setOtherFilter({
            ...other_filter,
            'id_establishment': parseInt(e.value),
        });
        let va = _get_all_purchase.data.datos.filter(x => parseInt(x.id_establecimiento) === parseInt(e.value));
        setDatas(va);
        setEstablishmentSelectFilter(e);
    }

    const initSelect = {
        id: 0,
        secuencial: "",
        codigo_establecimiento: "",
        establecimiento: "",
        estado: "",
        fecha_creacion: "",
        fecha_aprobacion: "",
        presupuesto: false,
        facturas: [],
        productos: [],
        productos_eliminados: [],
        valores: 0,
        estimado: 0,
        marca: 0,
        serie: 0,
        total_estimado: 0,
        total: 0,
        colspan: 2,
        descripcion: '',
        observacion: '',
    };

    const [DataSelected, setDataSelected] = useState(initSelect);
    const [modalConfirm, setModalConfirm] = useState(false);
    const [modalValidar, setModalValidar] = useState(false);
    const [modalDecline, setModalDecline] = useState(false);
    const [modalAccept, setModalAccept] = useState(false);
    const [modalProduct, setModalProduct] = useState(false);
    const [modalAdjustment, setModalAdjustment] = useState(false);
    const [deleted, setDeleted] = useState(false);
    const [invoices, setInvoices] = useState([]);
    const [idReason, setIdReason] = useState(0);
    const [idDetail, setIdDetail] = useState(0);
    const [itemSelect, setItemSelect] = useState([]);
    const [observation, setObservation] = useState('');

    const onItemClickListener = async (item) => {
        const response = await getItemPurchase(token, item.id);
        if (response && response.data && response.data.datos) {
            setDataSelected(response.data.datos[0]);
        }
        setShowDetail(true);
    }

    useEffect(() => {
        if (_update_purchase.status === 200) {
            toast.success(_update_purchase.data.mensaje);
            dispatch(clear_purchase(UPDATE_PURCHASE));
            // eslint-disable-next-line
            dispatch(getAllPurchase(token));
            setIsLoading(false);
            setModalDecline(false);
            setModalProduct(false);
            setModalAccept(false);
            setModalValidar(false);
            setModalConfirm(false);
            setModalAdjustment(false);
            setShowDetail(false);
        } else if (_update_purchase.status !== 0) {
            toast.error(_update_purchase.message);
            dispatch(clear_purchase(UPDATE_PURCHASE));
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_update_purchase, dispatch]);

    const handleChangeFiles = (e) => {
        const files = Array.from(e.target.files);
        setInvoices(files);
    }

    const handleSubmitApproval = (e) => {
        e.preventDefault();
        setIsLoading(true);
        dispatch(updatePurchase(token, DataSelected.id, {"estado": "APROBADO"}));
    }

    const handleSubmitConfirm = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (invoices.length === 0) {
            toast.error("Debe seleccionar al menos una factura");
            setIsLoading(false);
            return;
        }
        let data = new FormData();
        // eslint-disable-next-line
        invoices.map((invoice) => {
            data.append('facturas', invoice);
        })
        data.append('estado', 'FINALIZADO');
        dispatch(updatePurchase(token, DataSelected.id, data))
    }

    const handleSubmitAccept = (e) => {
        e.preventDefault();
        setIsLoading(true);
        let valid = true;
        // eslint-disable-next-line
        itemSelect.map((item) => {
            if (item.checked === true && item.valor === 0 && valid === true) {
                toast.error("Debe ingresar un valor estimado para el producto " + item.producto);
                setIsLoading(false);
                valid = false;
                // eslint-disable-next-line
                return;
            }
        });

        if (valid) {
            dispatch(updatePurchase(token, DataSelected.id, {'estado': 'ACEPTADO', 'items': itemSelect}));
        }
    }

    const handleSubmitConfirmOperation = (e) => {
        e.preventDefault();
        setIsLoading(true);
        dispatch(updatePurchase(token, DataSelected.id, {'estado': 'CONFIRMADO'}));
    }

    const handleValidateSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        let valid = true;
        // eslint-disable-next-line
        itemSelect.map((item) => {
            if (item.checked === true && item.valor === 0 && valid === true) {
                toast.error("Debe ingresar un valor para el producto " + item.producto);
                setIsLoading(false);
                valid = false;
                // eslint-disable-next-line
                return;
            }
        });

        if (valid) {
            dispatch(updatePurchase(token, DataSelected.id, {'items': itemSelect, 'estado': 'COTIZADO'}));
        }
    }

        const handleAdjustmentSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        dispatch(updatePurchase(token, DataSelected.id, {'observacion': observation, 'estado': 'AJUSTES ADICIONALES'}));
    }

    useEffect(() => {
        if (_delete_detail_purchase.status === 200) {
            toast.success(_delete_detail_purchase.data.mensaje);
            dispatch(clear_detail_purchase(DELETE_DETAIL_PURCHASE));
            onItemClickListener(DataSelected);
            setModalDecline(false);
            setIsLoading(false);
        } else if (_delete_detail_purchase.status !== 0) {
            toast.error(_delete_detail_purchase.message);
            dispatch(clear_detail_purchase(DELETE_DETAIL_PURCHASE));
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_delete_detail_purchase, dispatch, DataSelected])

    const handleDeclineSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (idReason === 0) {
            toast.error("Debe seleccionar un motivo");
            setIsLoading(false);
            return;
        }
        if (idDetail === 0) {
            dispatch(updatePurchase(token, DataSelected.id, {"estado": "RECHAZADO", "id_motivo": idReason}));
        } else {
            dispatch(deleteDetailPurchase(token, idDetail, idReason));
        }
    }

    const initProduct = {
        producto_id: 0,
        compra_id: DataSelected.id,
        qty: 0,
        producto: '',
        descripcion: '',
    };

    // eslint-disable-next-line
    const [product, setProduct] = useState(initProduct);

    const handleChangeProduct = (e) => {
        setProduct({
            ...product,
            [e.target.name]: e.target.value,
        });
    }

    const [product_select, setProductSelect] = useState([]);

    const handleChangeProducts = (e) => {
        setProduct({
            ...product,
            producto_id: parseInt(e.value),
            producto: e.label,
        });
        setProductSelect(e);
    }

    useEffect(() => {
        if (_create_detail_purchase.status === 201) {
            toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_detail_purchase(CREATE_DETAIL_PURCHASE));
            onItemClickListener(DataSelected);
            setIsLoading(false);
            setModalProduct(false);
        } else if (_create_detail_purchase.status !== 0) {
            dispatch(clear_detail_purchase(CREATE_DETAIL_PURCHASE));
            toast.error(_create_detail_purchase.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_create_detail_purchase, dispatch, DataSelected]);

    const [constant, setConstant] = useState(0);

    const handleProductSubmit = (e) => {
        e.preventDefault();
        if (product.producto_id === 0) {
            toast.error("Debe seleccionar un producto");
            return;
        } else {
            let p = [];
            if (constant === 0) {
                p = products.filter((item) => item.producto_id === product.producto_id)
            }
            if (constant === 1) {
                p = DataSelected.productos.filter((item) => item.producto_id === product.producto_id && item.eliminado === false)
            }
            if (p.length > 0) {
                toast.error("El producto ya se encuentra en la lista");
                return;
            }
        }
        if (product.qty === 0) {
            toast.error("La cantidad debe ser mayor a 0");
            return;
        }
        if (constant === 0) {
            setProducts([...products, product]);
            setModalProduct(false);
            setProduct(initProduct);
        }
        if (constant === 1) {
            dispatch(createDetailPurchase(token, product))
        }

    }

    function handleChangeItem(e, id) {
        if (id === 0) {
            const all = itemSelect.map((p) =>
              p.id !== id ? { ...p, checked: e.target.checked } : p
            );
            setItemSelect(all);
            setAllChecked(!allChecked);
        } else {
            const item = itemSelect.map((p) =>
              p.id === id ? { ...p, checked: e.target.checked } : p
            );
            setItemSelect(item);
        }
    }

    function handleChangeItemValue(e, id) {
        const item = itemSelect.map((p) =>
          p.id === id ? { ...p, valor: parseFloat(e.target.value) } : p
        );
        setItemSelect(item);
    }

    function handleChangeItemBrand(e, id) {
        const item = itemSelect.map((p) =>
          p.id === id ? { ...p, marca: e.target.value } : p
        );
        setItemSelect(item);
    }

    // function handleChangeItemSerieNumber(e, id) {
    //     const item = itemSelect.map((p) =>
    //       p.id === id ? { ...p, numero_serie: e.target.value } : p
    //     );
    //     setItemSelect(item);
    // }

    return (
        <div className="app-content content">
            <ToastContainer/>
            {isLoading && <LoadingSpinner/>}
            <div className="content-wrapper">

                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 ">
                        <Breadcrumbs
                            title="Compras"
                            items={[{label: "Listado compras", link: "/compras"}]}
                            onclick
                        />
                    </div>
                </div>
                <div className="content-body">

                    <div className="content-area-wrapper" style={{margin: 0}}>


                        <div className={`sidebar-left ${showSibarLeft ? 'show' : ''}`}>
                            <div className="sidebar">

                                <div className="sidebar-content email-app-sidebar d-flex">
                                    {/* sidebar close icon */}
                                    <span className="sidebar-close-icon" onClick={
                                        () => {
                                            setShowSibarLeft(false)
                                            setShowOverlay(false)
                                        }
                                    }>
                                        <i className="bx bx-x"/>
                                    </span>
                                    {/* sidebar close icon */}
                                    <div className="email-app-menu">
                                        <div className="form-group form-group-compose">
                                            {/* compose button  */}
                                            {
                                                permisos.filter(element => element.codigo === "add_purchases").length > 0 &&
                                                <Button
                                                    text="Crear"
                                                    onChange={() => {
                                                        setShowSibarRight(!showSibarRight);
                                                        setShowSibarLeft(false);
                                                        setShowDetail(false);
                                                        setForm(initForm)
                                                        setShowOverlay(!showSibarRight);
                                                        setEstablishmentSelect([]);
                                                        setProducts([]);
                                                    }}
                                                    theme="success"
                                                    classes=" btn-block my-2 compose-btn"
                                                />
                                            }
                                        </div>
                                        <div className="sidebar-menu-list">
                                            {/* sidebar menu  */}
                                            <div className="list-group list-group-messages">
                                                <SelectInput
                                                    id="filtro-purchasea"
                                                    name="filtro-purchasea"
                                                    options={filter_options}
                                                    onChange={filterToday}
                                                />
                                                <ul className="list-unstyled mb-0">
                                                    {range_date.visible &&
                                                        <>
                                                            <li className=" mr-2 mb-1">
                                                                <Input
                                                                    type="date"
                                                                    label="Fecha Inicio"
                                                                    onChange={handleFilterRangeDate}
                                                                    name='date_start'

                                                                />
                                                                <Input
                                                                    type="date"
                                                                    label="Fecha Fin"
                                                                    onChange={handleFilterRangeDate}
                                                                    name='date_end'

                                                                />
                                                            </li>
                                                        </>
                                                    }
                                                    {other_filter.visible_establishment &&
                                                        <>
                                                            <li className=" mr-2 mb-1">
                                                                <label className="form-label">Establecimiento</label>
                                                                <Select
                                                                    options={establishment}
                                                                    isMulti={false}
                                                                    onChange={handleChangeEstablishmentFilter}
                                                                    value={establishment_select_filter}
                                                                />

                                                            </li>
                                                        </>
                                                    }
                                                </ul>
                                            </div>
                                            {/* sidebar label end */}
                                        </div>
                                    </div>
                                </div>
                                {/* User new mail right area */}
                                {

                                    permisos.filter(element => element.codigo === "add_purchases").length > 0 ?
                                        <div className={`compose-new-mail-sidebar ${showSibarRight ? 'show' : ''} div_purchases`}
                                             style={{
                                                 overflowY: 'scroll',
                                             }}
                                        >
                                            <div className="card shadow-none quill-wrapper p-0">
                                                <div className="card-header">
                                                    <h3 className="card-title" id="purchasea">
                                                        Nueva compra
                                                    </h3>
                                                    <button type="button" className="close close-icon"
                                                            onClick={() => {
                                                                setShowSibarRight(false);
                                                                setShowSibarLeft(false);
                                                                setShowOverlay(false);
                                                            }}
                                                    >
                                                        <i className="bx bx-x"/>
                                                    </button>
                                                </div>
                                                {/* form start */}
                                                <form onSubmit={handleSubmit} id="compose-form">
                                                    <div className="card-content">
                                                        <div className="card-body pt-0">
                                                            <label className="form-label">Establecimiento</label>
                                                            <Select
                                                                options={establishment}
                                                                isMulti={false}
                                                                onChange={handleChangeEstablishment}
                                                                value={establishment_select}
                                                            />
                                                            <br/>
                                                            <Input
                                                                label="Descripción"
                                                                name="descripcion"
                                                                value={form.descripcion}
                                                                onChange={handleChange}
                                                            />
                                                            <br/>
                                                            <CheckBox label="¿Cuenta con presupuesto?"
                                                                      name="presupuesto" id="presupuesto"
                                                                      onChange={handleChangePresupuesto}
                                                                      state={form.presupuesto}/>
                                                            <br/>
                                                            <div className="text-right">
                                                                <Button
                                                                    text="Añadir producto"
                                                                    onChange={() => {
                                                                        dispatch(getAllProduct(token));
                                                                        setConstant(0);
                                                                        setProductSelect([]);
                                                                        setProduct(initProduct);
                                                                        setModalProduct(true);
                                                                    }}
                                                                    theme="warning"
                                                                    type="button"
                                                                    disabled={isLoading}
                                                                />
                                                            </div>
                                                            <div className="mt-1">
                                                                {products.length > 0 &&
                                                                    <table className="table table-striped">
                                                                        <tr>
                                                                            <th className="text_request_shipping">Producto</th>
                                                                            <th className="text_request_shipping">Descripción</th>
                                                                            <th className="text_request_shipping">Cantidad</th>
                                                                            <th className="text_request_shipping"></th>
                                                                        </tr>
                                                                        {products.map((j, index) => (
                                                                            <tr>
                                                                                <td className="text_request_shipping">{j.producto}</td>
                                                                                <td className="text_request_shipping">{j.descripcion}</td>
                                                                                <td className="text_request_shipping text-center">{j.qty}</td>
                                                                                <td className="text_request_shipping text-right">
                                                                                    {/*eslint-disable-next-line*/}
                                                                                    <a href="#" onClick={() => {
                                                                                        products.splice(index, 1);
                                                                                    }}>
                                                                                        <i className="badge-circle badge-circle-light-danger bx bxs-trash"/>
                                                                                    </a>
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </table>
                                                                }
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div className="card-footer d-flex justify-content-end pt-0">
                                                        <Button
                                                            text="Cancelar"
                                                            theme="light-secondary"
                                                            type="reset"
                                                            classes="cancel-btn mr-1"
                                                            onChange={() => {
                                                                setShowSibarRight(false);
                                                                setShowOverlay(!showOverlay);
                                                            }}
                                                        />
                                                        <Button
                                                            text="Guardar"
                                                            onChange={() => {
                                                                //TODO: AGREGAR FUNCIONALIDAD DE CREAR PURCHASE
                                                            }}
                                                            theme="success"
                                                            type="submit"
                                                            disabled={isLoading}
                                                        />
                                                    </div>
                                                </form>
                                                {/* form start end*/}
                                            </div>
                                        </div> : null}
                                {/*/ User Chat profile right area */}
                            </div>
                        </div>
                        <div className="content-right">
                            <div className="content-overlay"/>
                            <div className="content-wrapper">
                                <div className="content-header row"/>
                                <div className="content-body">
                                    {/* email app overlay */}
                                    <div className={`app-content-overlay ${showOverlay ? 'show' : ''}`}
                                         onClick={
                                             () => {
                                                 setShowSibarRight(!showSibarRight);
                                                 setShowSibarLeft(false);
                                                 setShowDetail(false);
                                                 setShowOverlay(!showOverlay);
                                             }
                                         }
                                    />
                                    <div className="email-app-area">
                                        {/* Email list Area */}
                                        <div className="email-app-list-wrapper">
                                            <div className="email-app-list">
                                                <div className="email-action">
                                                    <div
                                                        className="action-right d-flex flex-grow-1 align-items-center justify-content-around">
                                                        {/* search bar  */}
                                                        <div className="email-fixed-search flex-grow-1">
                                                            <div className="sidebar-toggle d-block d-lg-none" onClick={
                                                                () => {
                                                                    setShowSibarLeft(!showSibarLeft);
                                                                    setShowOverlay(!showOverlay);
                                                                }
                                                            }>
                                                                <i className="bx bx-menu"/>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-10">
                                                                    <Search placeholder={"Buscar por establecimiento o número de solicitud"} onChange={handleSearch}/>
                                                                </div>
                                                                { permisos && permisos.filter(x => x.codigo === 'generate_report_purchases').length > 0 &&
                                                                    <div className="col-2">
                                                                        <Button
                                                                            text={<h3><i className="text-white bx bx-export"/></h3>}
                                                                            theme="success"
                                                                            type="button"
                                                                            classes="btn-lg round"
                                                                            onClick={handleGenerateReport}
                                                                        />
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                        {/* pagination and page count */}
                                                    </div>
                                                </div>
                                                {/* / action right */}

                                                {/* email user list start */}
                                                <div className="email-user-list list-group">
                                                    <ul className="users-list-wrapper media-list" style={{
                                                        overflowY: 'scroll',
                                                    }}>
                                                        <InfiniteScroll
                                                            pageStart={0}
                                                            loadMore={() => loadFunc()}
                                                            hasMore={HasMore}
                                                            useWindow={false}

                                                            loader={
                                                                <div className="col-12 d-flex justify-content-center">
                                                                    <div
                                                                        className="spinner-border text-success"
                                                                        role="status"
                                                                    >
                                                                        <span className="sr-only">Loading...</span>
                                                                    </div>
                                                                    {" "}
                                                                </div>
                                                            }
                                                        >
                                                            {datas.map((item, index) => (
                                                                <ItemList1
                                                                    item={item}
                                                                    title={item.establecimiento + ' (' + item.codigo_establecimiento + ')'}
                                                                    subtitle={item.secuencial}
                                                                    rightDescription={item.estado}
                                                                    bulletType={get_status(item.estado)}
                                                                    children={
                                                                        <>
                                                                            <div className="user-details div_fecha">
                                                                                <div className="mail-items">
                                                                                    <small>{item.descripcion}</small><br/>
                                                                                    <small>Fecha: {item.fecha_creacion}</small>
                                                                                </div>
                                                                                <div className="email-items">
                                                                                    <span>{item.presupuesto ? 'Tiene presupuesto: SI' : 'Tiene presupuesto: NO'}</span>
                                                                                </div>

                                                                            </div>
                                                                        </>
                                                                    }
                                                                    onClick={onItemClickListener}
                                                                />
                                                            ))}
                                                        </InfiniteScroll>
                                                    </ul>
                                                    {/* email user list end */}

                                                    {/* no result when nothing to show on list */}
                                                    <div className="no-results">
                                                        <i className="bx bx-error-circle font-large-2"/>
                                                        <h5>No Items Found</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/*/ Email list Area */}
                                        {/* Detailed Email View */}
                                        <div className={`email-app-details ${showDetail ? 'show' : ''} `}>
                                            {/* email detail view header */}
                                            <div className="email-detail-header">
                                                <div className="email-header-left d-flex align-items-center mb-1">
                                                    <span className="go-back mr-50" onClick={
                                                        () => {
                                                            setShowDetail(false);
                                                        }
                                                    }>
                                                        <span className="fonticon-wrap d-inline">
                                                        <i className="bx bx-arrow-back"/>
                                                        </span>
                                                    </span>
                                                    <h5 className="email-detail-title font-weight-normal mb-0">
                                                        {DataSelected.secuencial}
                                                    </h5>
                                                </div>
                                                <div className="email-header-right mb-1 ml-2 pl-1">
                                                    <span
                                                        className={`badge badge-light-${get_status(DataSelected.estado)} badge-pill ml-1`}>
                                                        {DataSelected.estado}
                                                    </span>
                                                </div>
                                            </div>
                                            {/* email detail view header end*/}
                                            <div className="email-scroll-area" style={{overflowY: 'scroll',}}>
                                                {/* email details  */}
                                                <div className="row">
                                                    <div className="col-12">
                                                        <div className="collapsible email-detail-head">
                                                            <Card
                                                                title={DataSelected.establecimiento + ' (' + DataSelected.codigo_establecimiento + ')'}
                                                            >
                                                                <div className="row">
                                                                    <div className="col-12 mb-1">
                                                                        <h6>Descripción: </h6>{DataSelected.descripcion}
                                                                    </div>
                                                                    <div className="col-md-6 col-12 mb-1">
                                                                        <h6>¿Cuenta con presupuesto?: </h6>{DataSelected.presupuesto ? 'SI' : 'NO'}
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    {(DataSelected.fecha_creacion) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Fecha de creación: </h6>{DataSelected.fecha_creacion}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.fecha_aprobacion) &&
                                                                        <div className="col-md-6 col-12 mb-1">
                                                                            <h6>Fecha de aprobación: </h6>{DataSelected.fecha_aprobacion}
                                                                        </div>
                                                                    }
                                                                </div>
                                                                <div className="row">
                                                                    {(DataSelected.facturas.length > 0) &&
                                                                        DataSelected.facturas.map(f => (
                                                                            <div className="col-md-4 col-12">
                                                                                <h6>Factura</h6>
                                                                                {/*eslint-disable-next-line*/}
                                                                                <a href={`${URLAPI}${f.factura}`} target="_blank">
                                                                                    <img
                                                                                        className="logo"
                                                                                        src="/base/app-assets/images/icon/pdf.png"
                                                                                        alt="logo"
                                                                                        style={{width: "100px",height: "auto", }}
                                                                                    />
                                                                                </a>
                                                                            </div>
                                                                        ))
                                                                    }
                                                                </div>
                                                                <div className="row">
                                                                    {(DataSelected.motivo) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Motivo: </h6>{DataSelected.motivo}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.observacion && DataSelected.estado === 'AJUSTES ADICIONALES') &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Observación: </h6>{DataSelected.observacion}
                                                                        </div>
                                                                    }
                                                                    <div className="table-responsive">
                                                                        {(permisos.filter(x => x.codigo === 'valid_purchases_operations').length > 0 && DataSelected.estado === "APROBADO") &&
                                                                        <div className="col-12 text-right">
                                                                            <Button
                                                                                text="Añadir producto"
                                                                                onChange={() => {
                                                                                    dispatch(getAllProduct(token));
                                                                                    setConstant(1);
                                                                                    setProductSelect([]);
                                                                                    setProduct(initProduct);
                                                                                    setModalProduct(true);
                                                                                }}
                                                                                theme="warning"
                                                                                type="button"
                                                                                disabled={isLoading}
                                                                            />
                                                                        </div>
                                                                        }
                                                                        <div className="col-12 mt-2">
                                                                            <h5>Productos</h5>
                                                                            {DataSelected.productos_eliminados.length > 0 &&
                                                                                <button type="button" className="btn btn-secondary" onClick={() => setDeleted(!deleted)}>{deleted ? <i className="bx bx-undo"/> : <i className="bx bx-trash"/>}</button>
                                                                            }
                                                                            <table className="mt-1 table table-bordered">
                                                                                <tr>
                                                                                    <th className="text-center">Producto</th>
                                                                                    <th className="text-center">Descripción</th>
                                                                                    <th className="text-center">Cantidad</th>
                                                                                    {DataSelected.estimado > 0 &&
                                                                                    <th className="text-center">Valor estimado</th>
                                                                                    }
                                                                                    {DataSelected.estimado > 0 &&
                                                                                    <th className="text-center">Total estimado</th>
                                                                                    }
                                                                                    {DataSelected.valores > 0 &&
                                                                                    <th className="text-center">Valor Real</th>
                                                                                    }
                                                                                    {DataSelected.valores > 0 &&
                                                                                    <th className="text-center">Total</th>
                                                                                    }
                                                                                    {DataSelected.marca > 0 &&
                                                                                    <th className="text-center">Marca</th>
                                                                                    }
                                                                                    {/*{DataSelected.serie > 0 &&*/}
                                                                                    {/*<th className="text-center">Número serie</th>*/}
                                                                                    {/*}*/}
                                                                                    {deleted &&
                                                                                        <th className="text-center">Motivo de rechazo</th>
                                                                                    }
                                                                                    {((permisos.filter(x => x.codigo === 'approval_purchases').length > 0 && DataSelected.estado === "CREADO") || (permisos.filter(x => x.codigo === 'valid_purchases_operations').length > 0 && DataSelected.estado === "APROBADO")) &&
                                                                                        <th className="text-center">Acción</th>
                                                                                    }
                                                                                </tr>
                                                                                {DataSelected.productos.map((j, index) => (
                                                                                    <tr>
                                                                                        <td>{j.producto}</td>
                                                                                        <td>{j.descripcion}</td>
                                                                                        <td className="text-center">{j.qty}</td>
                                                                                        {DataSelected.estimado > 0 &&
                                                                                        <td className="text-right">{j.valor_estimado}</td>
                                                                                        }
                                                                                        {DataSelected.estimado > 0 &&
                                                                                        <td className="text-right">{j.total_estimado}</td>
                                                                                        }
                                                                                        {DataSelected.valores > 0 &&
                                                                                        <td className="text-right">{j.valor}</td>
                                                                                        }
                                                                                        {DataSelected.valores > 0 &&
                                                                                        <td className="text-right">{j.total}</td>
                                                                                        }
                                                                                        {DataSelected.marca > 0 &&
                                                                                        <td>{j.marca}</td>
                                                                                        }
                                                                                        {/*{DataSelected.serie > 0 &&*/}
                                                                                        {/*<td>{j.numero_serie}</td>*/}
                                                                                        {/*}*/}
                                                                                        {deleted &&
                                                                                        <td>{j.motivo}</td>
                                                                                        }
                                                                                        {((permisos.filter(x => x.codigo === 'approval_purchases').length > 0 && DataSelected.estado === "CREADO") || (permisos.filter(x => x.codigo === 'valid_purchases_operations').length > 0 && DataSelected.estado === "APROBADO")) &&
                                                                                        <td className="text-center">
                                                                                            {!j.eliminado &&
                                                                                                <>
                                                                                                    {/*eslint-disable-next-line*/}
                                                                                                    <a onClick={() => {
                                                                                                        dispatch(getAllReasonPurchases(token));
                                                                                                        setIdDetail(j.id);
                                                                                                        setModalDecline(true);
                                                                                                    }}>
                                                                                                        <i className={`badge-circle badge-circle-light-danger bx bx-trash font-medium-1`}/>
                                                                                                    </a>
                                                                                                </>
                                                                                            }
                                                                                        </td>
                                                                                        }
                                                                                    </tr>
                                                                                ))}
                                                                                {deleted && DataSelected.productos_eliminados.map((pe) => (
                                                                                    <tr>
                                                                                        <td>{pe.producto}</td>
                                                                                        <td>{pe.descripcion}</td>
                                                                                        <td className="text-center">{pe.qty}</td>
                                                                                        {DataSelected.estimado > 0 &&
                                                                                        <td className="text-right">{pe.valor_estimado}</td>
                                                                                        }
                                                                                        {DataSelected.estimado > 0 &&
                                                                                        <td className="text-right">{pe.total_estimado}</td>
                                                                                        }
                                                                                        {DataSelected.valores > 0 &&
                                                                                        <td className="text-right">{pe.valor}</td>
                                                                                        }
                                                                                        {DataSelected.valores > 0 &&
                                                                                        <td className="text-right">{pe.total}</td>
                                                                                        }
                                                                                        {DataSelected.marca > 0 &&
                                                                                        <td>{pe.marca}</td>
                                                                                        }
                                                                                        {/*{DataSelected.serie > 0 &&*/}
                                                                                        {/*<td>{pe.numero_serie}</td>*/}
                                                                                        {/*}*/}
                                                                                        <td>{pe.motivo}</td>
                                                                                        {((permisos.filter(x => x.codigo === 'approval_purchases').length > 0 && DataSelected.estado === "CREADO") || (permisos.filter(x => x.codigo === 'valid_purchases_operations').length > 0 && DataSelected.estado === "APROBADO")) &&
                                                                                        <td></td>
                                                                                        }
                                                                                    </tr>
                                                                                ))}
                                                                                {(DataSelected.estimado > 0 || DataSelected.valores > 0) &&
                                                                                    <tr>
                                                                                        <th colSpan={DataSelected.colspan}>Total</th>
                                                                                        {DataSelected.estimado > 0 &&
                                                                                        <th className="text-right">{DataSelected.total_estimado}</th>
                                                                                        }
                                                                                        {DataSelected.valores > 0 &&
                                                                                        <th className="text-right"></th>
                                                                                        }
                                                                                        {DataSelected.valores > 0 &&
                                                                                        <th className="text-right">{DataSelected.total}</th>
                                                                                        }
                                                                                    </tr>
                                                                                }
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-12 div-flex mt-2 mb-5">
                                                                        {(permisos.filter(x => x.codigo === 'approval_purchases').length > 0 && DataSelected.estado === "CREADO") &&
                                                                            <>
                                                                                <Button
                                                                                    text="Rechazar"
                                                                                    onChange={() => {
                                                                                        dispatch(getAllReasonPurchases(token));
                                                                                        setIdReason(0);
                                                                                        setIdDetail(0);
                                                                                        document.getElementById("motivo").selectedIndex = 0;
                                                                                        setModalDecline(true);
                                                                                    }}
                                                                                    theme="danger"
                                                                                    classes="button_div1"
                                                                                    type="button"
                                                                                    disabled={isLoading}
                                                                                />
                                                                                <Button
                                                                                    text="Aprobar"
                                                                                    onChange={handleSubmitApproval}
                                                                                    theme="success"
                                                                                    classes="button_div1"
                                                                                    type="button"
                                                                                    disabled={isLoading}
                                                                                />
                                                                            </>
                                                                        }
                                                                        {(permisos.filter(x => x.codigo === 'valid_purchases_operations').length > 0 && DataSelected.estado === "APROBADO") &&
                                                                            <>
                                                                                <Button
                                                                                    text="Rechazar"
                                                                                    onChange={() => {
                                                                                        dispatch(getAllReasonPurchases(token));
                                                                                        setIdReason(0);
                                                                                        setIdDetail(0);
                                                                                        document.getElementById("motivo").selectedIndex = 0;
                                                                                        setModalDecline(true);
                                                                                    }}
                                                                                    theme="danger"
                                                                                    classes="button_div1"
                                                                                    type="button"
                                                                                    disabled={isLoading}
                                                                                />
                                                                                <Button
                                                                                    text="Aceptar compra"
                                                                                    onChange={() => {
                                                                                        let array = [];
                                                                                        // eslint-disable-next-line
                                                                                        DataSelected.productos.map(p => {
                                                                                            array.push({
                                                                                                id: p.id,
                                                                                                producto: p.producto,
                                                                                                descripcion: p.descripcion,
                                                                                                qty: p.qty,
                                                                                                valor: 0
                                                                                            });
                                                                                        });
                                                                                        setItemSelect(array);
                                                                                        setModalAccept(true);
                                                                                    }}
                                                                                    theme="success"
                                                                                    classes="button_div1"
                                                                                    type="button"
                                                                                    disabled={isLoading}
                                                                                />
                                                                            </>
                                                                        }
                                                                        {(permisos.filter(x => x.codigo === 'valid_purchases').length > 0 && (DataSelected.estado === "ACEPTADO" || DataSelected.estado === "AJUSTES ADICIONALES")) &&
                                                                            <Button
                                                                                text="Agregar cotización"
                                                                                onChange={() => {
                                                                                    let array = [];
                                                                                    // eslint-disable-next-line
                                                                                    DataSelected.productos.map(p => {
                                                                                        array.push({
                                                                                            id: p.id,
                                                                                            producto: p.producto,
                                                                                            descripcion: p.descripcion,
                                                                                            checked: false,
                                                                                            valor: parseFloat(p.valor),
                                                                                            marca: p.marca,
                                                                                            // numero_serie: p.numero_serie,
                                                                                        });
                                                                                    });
                                                                                    setItemSelect(array);
                                                                                    setAllChecked(false);
                                                                                    setModalValidar(true);
                                                                                }}
                                                                                theme="success"
                                                                                classes="button_div1"
                                                                                type="button"
                                                                                disabled={isLoading}
                                                                            />
                                                                        }
                                                                        {(permisos.filter(x => x.codigo === 'confirm_purchases').length > 0 && DataSelected.estado === "COTIZADO") &&
                                                                            <>
                                                                                <Button
                                                                                    text="Ajustes adicionales"
                                                                                    onChange={() => {
                                                                                        setObservation('');
                                                                                        setModalAdjustment(true);
                                                                                    }}
                                                                                    theme="danger"
                                                                                    classes="button_div1"
                                                                                    type="button"
                                                                                    disabled={isLoading}
                                                                                />
                                                                                <Button
                                                                                    text="Aprobar compra"
                                                                                    onChange={handleSubmitConfirmOperation}
                                                                                    theme="success"
                                                                                    classes="button_div1"
                                                                                    type="button"
                                                                                    disabled={isLoading}
                                                                                />
                                                                            </>
                                                                        }
                                                                        {(permisos.filter(x => x.codigo === 'valid_purchases').length > 0 && DataSelected.estado === "CONFIRMADO") &&
                                                                            <Button
                                                                                text="Confirmar compra"
                                                                                onChange={() => {
                                                                                    setInvoices([]);
                                                                                    setModalConfirm(true);
                                                                                }}
                                                                                theme="success"
                                                                                classes="button_div1"
                                                                                type="button"
                                                                                disabled={isLoading}
                                                                            />
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </Card>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* email details  end*/}
                                                <div className="row px-2 mb-4">
                                                    {/* quill editor for reply message */}
                                                    <div className="col-12 px-0"/>
                                                </div>
                                            </div>
                                        </div>
                                        {/*/ Detailed Email View */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal1" show={modalConfirm}>
                <form onSubmit={handleSubmitConfirm}>
                    {isLoading && <LoadingSpinner />}
                    <div className="card-body">
                        <h5 className="titulo_modal mb-2">Adjunte la(s) factura(s) de compra</h5>
                        <div className="form-group">
                            <label>Seleccione una o varias facturas</label>
                            <input className="form-control" type="file" multiple accept=".docx,.pdf" onChange={handleChangeFiles} />
                            {/*<Input*/}
                            {/*    label="Factura"*/}
                            {/*    name="archivo"*/}
                            {/*    type="file"*/}
                            {/*    accept=".docx,.pdf"*/}
                            {/*    onChange={handleChangeFiles}*/}
                            {/*/>*/}
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-success button_div mt-1`}>Confirmar
                        </button>
                        <button type="button" onClick={() => {
                            setModalConfirm(false);
                        }} className={`btn btn-outline-dark button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Modal className="modal-main div-modal1" show={modalValidar} auto="230%">
                <form onSubmit={handleValidateSubmit}>
                    {isLoading && <LoadingSpinner />}
                    <div className="card-body">
                        <h5 className="titulo_modal mb-2">Validar productos</h5>
                        <div className="form-group">
                            <table className="mt-1 table table-bordered">
                                <tr>
                                    <td className="text-center" style={{display: "grid"}}>
                                        <label>Todos</label>
                                        <input id="all" className="form-check-input" type="checkbox" checked={allChecked} style={{transform: 'scale(1.5)'}} onChange={(e) => handleChangeItem(e, 0)}/>
                                    </td>
                                    <th className="text-center">Producto</th>
                                    <th className="text-center">Descripción</th>
                                    <th className="text-center">Valor por unidad</th>
                                    <th className="text-center">Marca</th>
                                    {/*<th className="text-center">Número de serie</th>*/}
                                </tr>
                                {itemSelect.map((j, index) => (
                                    <tr>
                                        <td><input id={j.id} checked={j.checked} className="form-check-input" type="checkbox" style={{transform: 'scale(1.5)'}} onChange={(e) => handleChangeItem(e, j.id)}/></td>
                                        <td>{j.producto}</td>
                                        <td>{j.descripcion}</td>
                                        <td className="text-center">
                                            {j.checked ?
                                                <input style={{width: 150}} className="form-control" value={j.valor} onChange={(e) => handleChangeItemValue(e, j.id)} type="number" min="0" step="0.01"/>
                                            :
                                                j.valor
                                            }
                                        </td>
                                        <td className="text-center">
                                            {j.checked ?
                                                <input style={{width: 150}} className="form-control" value={j.marca} onChange={(e) => handleChangeItemBrand(e, j.id)}/>
                                            :
                                                j.marca
                                            }
                                        </td>
                                        {/*<td className="text-center">*/}
                                        {/*    {j.checked ?*/}
                                        {/*        <input style={{width: 150}} className="form-control" value={j.numero_serie} onChange={(e) => handleChangeItemSerieNumber(e, j.id)}/>*/}
                                        {/*    :*/}
                                        {/*        j.numero_serie*/}
                                        {/*    }*/}
                                        {/*</td>*/}
                                    </tr>
                                ))}
                            </table>
                        </div>

                    </div>
                    <div className="card-footer text-center">
                    <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-success button_div mt-1`}>Guardar
                        </button>
                        <button type="button" onClick={() => {
                            setModalValidar(false);
                        }} className={`btn btn-outline-dark button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Modal className="modal-main div-modal1" show={modalAccept} auto="180%">
                <form onSubmit={handleSubmitAccept}>
                    {isLoading && <LoadingSpinner />}
                    <div className="card-body">
                        <h5 className="titulo_modal mb-2">Precios estimados</h5>
                        <div className="form-group">
                            <table className="mt-1 table table-bordered">
                                <tr>
                                    <th className="text-center">Producto</th>
                                    <th className="text-center">Descripción</th>
                                    <th className="text-center">Cantidad</th>
                                    <th className="text-center">Precio estimado por unidad</th>
                                </tr>
                                {itemSelect.map((j, index) => (
                                    <tr>
                                        <td>{j.producto}</td>
                                        <td>{j.descripcion}</td>
                                        <td className="text-center">{j.qty}</td>
                                        <td className="text-center">
                                            <input style={{width: 180}} className="form-control" value={j.valor} onChange={(e) => handleChangeItemValue(e, j.id)} type="number" min="0" step="0.01"/>
                                        </td>
                                    </tr>
                                ))}
                            </table>
                        </div>

                    </div>
                    <div className="card-footer text-center">
                    <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-success button_div mt-1`}>Guardar
                        </button>
                        <button type="button" onClick={() => {
                            setModalAccept(false);
                        }} className={`btn btn-outline-dark button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Modal className="modal-main div-modal1" show={modalDecline}>
                <form onSubmit={handleDeclineSubmit}>
                    {isLoading && <LoadingSpinner />}
                    <div className="card-body">
                        <h5 className="titulo_modal mb-2">Rechazar</h5>
                        <div className="form-group">
                            <label>Motivo</label>
                            <SelectInput
                                id="motivo"
                                label="motivo"
                                name="idReason"
                                onChange={(e) => setIdReason(parseInt(e.target.value))}
                                options={reasonPurchase ? reasonPurchase.map((item) => ({
                                    name: item.descripcion,
                                    id: item.id,
                                })) : []}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-success button_div mt-1`}>Aceptar
                        </button>
                        <button type="button" onClick={() => {
                            setModalDecline(false);
                        }} className={`btn btn-outline-dark button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Modal className="modal-main div-modal1" show={modalProduct}>
                <form onSubmit={handleProductSubmit}>
                    {isLoading && <LoadingSpinner />}
                    <div className="card-body">
                        <h5 className="titulo_modal mb-2">Añadir producto</h5>
                        <div className="form-group">
                            <label className="form-label">Producto</label>
                            <Select
                                options={optionProducts}
                                isMulti={false}
                                onChange={handleChangeProducts}
                                value={product_select}
                            />
                        </div>
                        <div className="form-group">
                            <Input
                                name="qty"
                                label="Cantidad"
                                onChange={handleChangeProduct}
                                type="number"
                                min="0"
                                value={product.qty}
                            />
                        </div>
                        <div className="form-group">
                            <TextArea
                                label="Descripción"
                                name="descripcion"
                                onChange={handleChangeProduct}
                                value={product.descripcion}
                                rows={5}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-success button_div mt-1`}>Guardar
                        </button>
                        <button type="button" onClick={() => {
                            setModalProduct(false);
                        }} className={`btn btn-outline-dark button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Modal className="modal-main div-modal1" show={modalAdjustment}>
                <form onSubmit={handleAdjustmentSubmit}>
                    {isLoading && <LoadingSpinner />}
                    <div className="card-body">
                        <h5 className="titulo_modal mb-2">Ajustes Adicionales</h5>
                        <div className="form-group">
                            <TextArea
                                label="Observación (Opcional)"
                                name="observacion"
                                onChange={(e) => setObservation(e.target.value)}
                                value={observation}
                                rows={5}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-success button_div mt-1`}>Guardar
                        </button>
                        <button type="button" onClick={() => {
                            setModalAdjustment(false);
                        }} className={`btn btn-outline-dark button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
        </div>
    );
};

export default PurchaseAdmin;
